export class Invoices {
  static root = '/invoices'
  static imports = `${Invoices.root}/imports`
  static sendNotification = `${Invoices.root}/notification/send`
  static delete = `${Invoices.root}/delete`
  static setPaid = `${Invoices.root}/set-paid`
  static importPreview = `${Invoices.imports}/preview`
  static columns = `${Invoices.imports}/columns`
  static importSummary = `${Invoices.imports}/summary`
  static saveMappings = Invoices.imports
  static getMappings = `${Invoices.saveMappings}/mappings`
}

export const AuthTest = {
  root: '/authtest',
}

export const Currencies = {
  get: '/currencies',
}

export const Contractors = {
  root: '/contractors',
  autocomplete: '/contractors/autocomplete',
  search: '/contractors/search',
}

export const Countries = {
  root: '/countries',
}

export const Settings = {
  root: '/settings',
  validation: '/settings/validations',
}

export const Lawsuits = {
  root: '/lawsuits',
  questions: '/lawsuits/questions',
  hyperlinks: '/lawsuits/hyperlinks',
  lawyers: {
    root: '/lawsuits/paged',
  },
}

export class Users {
  static root = '/users'
  static currentUser = `${Users.root}/me`
  static register = `${Users.root}/register`
  static accountant = `${Users.root}/accountant`
  static company = `${Users.root}/company`
  static powerOfAttorney = `${Users.root}/power-of-attorney`
  static withdrawPowerOfAttorney = `${Users.powerOfAttorney}/withdraw`
  static config = `${Users.root}/config`
  static dashboard = `${Users.root}/dashboard`
  static feedbacks = `${Users.root}/feedbacks`
  static subscription = `${Users.root}/subscription`
  static notificationSettings = `${Users.root}/notification-settings`
}

export class Files {
  static root = '/files'
  static templates = `${Files.root}/templates`
  static powerOfAttorneyTemplate = `${Files.templates}/power-of-attorney`
  static invoiceImport = `${Files.templates}/invoice-import`
}

export class Companies {
  static root = '/companies'
  static search = `${Companies.root}/search`
}

export class Accountants {
  static root = '/accountants'
  static companies = `${Accountants.root}/companies`
}

export class Products {
  static root = '/products'
  static subscriptions = `${Products.root}/subscriptions`
  static additionalPackages = `${Products.root}/additional-packages`
  static administrativePayment = `${Products.root}/administration-fee`
}

export class Accounts {
  static root = '/accounts'
  static language = `${Accounts.root}/language`
}

export class Languages {
  static root = '/languages'
}

export class Payments {
  static root = '/payments'
  static paymentMethods = `${Payments.root}/payment-methods`
  static carts = `${Payments.root}/carts`
  static orders = `${Payments.root}/orders`
}

export class BankAccounts {
  static root = '/bank-accounts'
}

export class Ksef {
  static root = '/ksef'
  static token = `${Ksef.root}/token`
  static connection = `${Ksef.root}/connection`
  static invoices = `${Ksef.root}/invoices`
  static sessions = `${Ksef.root}/sessions`
  static rerun = `${Ksef.sessions}/rerun`
  static summary = `${Ksef.sessions}/summary`
  static displayed = `${Ksef.sessions}/displayed`
}
